<div class="row">
  <div class="col d-flex justify-content-center">
    <div class="EmailLoginForm__Wrapper d-flex">
      <form
        [formGroup]="loginForm"
        class="d-flex flex-wrap"
        (submit)="handleSubmit($event)"
      >
        @if (forgotPassword) {
          <h4 class="EmailLoginForm__Header">
            Enter the email associated with your account to continue
          </h4>
        }
        <ion-item>
          <ion-label position="floating">Email:</ion-label>
          <ion-input
            id="email"
            name="email"
            type="email"
            formControlName="email"
            required="true"
          ></ion-input>
        </ion-item>
        @if (!forgotPassword) {
          <ion-item>
            <ion-label position="floating">Password:</ion-label>
            <ion-input
              type="password"
              name="password"
              id="password"
              formControlName="password"
              required="true"
              [disabled]="forgotPassword"
            ></ion-input>
          </ion-item>
        }
        @if (!newAccount) {
          <ion-button
            class="EmailLoginForm__StateButton EmailLoginForm__ForgotPasswordButton"
            fill="clear"
            type="button"
            [innerHTML]="forgotPasswordText$ | async"
            (click)="toggleForgotPassword()"
          ></ion-button>
        }
        @if (newAccount) {
          <ion-item>
            <ion-label position="floating">Confirm Password:</ion-label>
            <ion-input
              type="password"
              name="confirm-password"
              formControlName="confirmPassword"
              required="true"
              [disabled]="!newAccount"
            ></ion-input>
          </ion-item>
          @if (loginForm.errors?.['PasswordNoMatch']) {
            <p class="warning">Passwords must match</p>
          }
        }
        @if (!forgotPassword) {
          <ion-button
            class="EmailLoginForm__StateButton"
            fill="clear"
            type="button"
            (click)="toggleCreateAccount()"
            [innerHTML]="toggleCreateText"
            data-test-id="forgotPasswordButton"
          ></ion-button>
        }

        @if (resettingPassword) {
          <ion-spinner></ion-spinner>
        } @else if (showPasswordResetConfirmation) {
          <p>Please check your email for a password reset link.</p>
        } @else {
          <ion-button
            fill="solid"
            color="primary"
            class="EmailLoginForm__LoginButton m-2 align-self-center"
            id="login-submit-button"
            type="submit"
            [innerHTML]="loginButtonText$ | async"
            [disabled]="loginForm.invalid"
            (click)="handleEmailLogin()"
          ></ion-button>
        }
        @if (error) {
          <p class="warning" [innerHTML]="error"></p>
        }
      </form>
    </div>
  </div>
</div>
